import React from "react";
import type { SimpleOfferCardProps } from "../SimpleOfferCard";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
import { isAnnualPeriod } from "@nf/common";
import { useIsAuthenticated } from "hooks";

const MediaButton = dynamic(() => import("components/MediaButton"));

const ChooseOfferButton = ({ offer }: SimpleOfferCardProps) => {
  const { isRegisteredViaCampaign } = useIsAuthenticated();
  const { t } = useTranslation("translations");

  return (
    <div className={"CTAButtonContainer"}>
      <MediaButton className={"ChooseOfferButton"} variant="primary">
        {t("web_choose_subscription")}
      </MediaButton>

      <span className={"OfferDesc"}>
        {isAnnualPeriod(offer.Period)
          ? t(
              isRegisteredViaCampaign
                ? "web_choose_subscription_annual_aeldresagen_usp"
                : "web_choose_subscription_annual_usp"
            )
          : t("web_landing_page__features__price_desc")}
      </span>
    </div>
  );
};

export default ChooseOfferButton;
